import { render, staticRenderFns } from "./script-input-editor.vue?vue&type=template&id=4c2618e1&scoped=true&"
import script from "./script-input-editor.vue?vue&type=script&lang=js&"
export * from "./script-input-editor.vue?vue&type=script&lang=js&"
import style0 from "./script-input-editor.vue?vue&type=style&index=0&id=4c2618e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2618e1",
  null
  
)

export default component.exports